'use client';

import React from 'react';
import dynamic from 'next/dynamic';

const RevenueChart = dynamic(() => import('./RevenueAreaChart'), { ssr: false });
const JobsCategoryChart = dynamic(() => import('./JobsCategoryChart'), { ssr: false });

export default function DashboardCharts() {
  return (
    <div className="space-y-6">
      <RevenueChart />
      <JobsCategoryChart />
    </div>
  );
}